<template>
  <div class="__DevTools-Permissions">
    <p class="text-sm">
      ※If nothing is checked, it means Admin.
    </p>
    <q-option-group v-model="enabledItems" :options="rbacOptions" type="checkbox" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { permissions } from '@/permissions';

export default Vue.extend({
  name: 'DevToolRbac',
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters('devTools', ['getPermissions']),

    enabledItems: {
      get() {
        return this.getPermissions;
      },
      set(val) {
        this.changePermissionEnabled(val);
      },
    },

    rbacOptions() {
      return permissions.map(i => {
        return {
          label: i,
          value: i,
          disable: this.disabled,
        };
      });
    },
  },
  methods: {
    ...mapActions('devTools', ['changePermissionEnabled']),
  },
});
</script>

<style lang="scss" scoped>
.__DevTools-Permissions {
  padding: 0 $space-md;
}
</style>
